import GeoJSON from 'ol/format/GeoJSON.js';
import union from '@turf/union';
import toTurf from '../utils/toTurf.js';
import fromTurf from '../utils/fromTurf.js';

/**
 * Returns the geometric union of two OpenLayers features using Turf.js.
 *
 * @param {ol.Feature} feature1 - The first OpenLayers feature.
 * @param {ol.Feature} feature2 - The second OpenLayers feature.
 * @param {string} mapProjection - The projection code of the map (e.g. "EPSG:3857").
 * @returns {ol.Feature|null} The resulting union feature, or null if failed.
 */
export default function getUnionTurf(feature1, feature2, mapProjection) {
  if (!feature1 || !feature2) {
    console.warn('getUnionTurf: both features are required.');
    return null;
  }

  const format = new GeoJSON();

  try {
    // Convert OpenLayers features to Turf.js geometries
    const turfFeat1 = toTurf(feature1, mapProjection, format);
    const turfFeat2 = toTurf(feature2, mapProjection, format);

    // Perform union
    const turfUnion = union(turfFeat1, turfFeat2);
    if (!turfUnion) {
      console.warn('getUnionTurf: Turf union failed or returned null.');
      return null;
    }

    // Convert back to OpenLayers feature
    return fromTurf(turfUnion, mapProjection, format);
  } catch (err) {
    console.error('getUnionTurf: failed to compute union:', err);
    return null;
  }
}
